<ion-list>
    <ion-item button *ngIf="navigationVerfuegbar" appClick (clicked)="onStarteNavigation()" lines="none">Navigation zum Einsatzort</ion-item>
    <ion-item button *ngIf="barcodeButtonVerfuegbar" appClick (clicked)="onAnzeigenBarcode()" lines="none">Barcode anzeigen</ion-item>
    <ion-item button *ngIf="isHandeingabeAktivierenVerfuegbar" appClick (clicked)="onAktiviereHandeingabe()" lines="none">Handeingabe aktivieren</ion-item>

    <ng-container *ngIf="isNeutralerWorkflow">
        <hr />
        <ion-item button appClick (clicked)="onAnsichtErzeuger()" lines="none">
            <ion-label>Ansicht Erzeuger</ion-label>
            <ion-icon name="checkmark" slot="end" *ngIf="auftragdetails.neutralAktuelleAnsicht == 1"></ion-icon>
        </ion-item>

        <ion-item button appClick (clicked)="onAnsichtEntsorger()" lines="none">
            <ion-label>Ansicht Entsorger</ion-label>
            <ion-icon name="checkmark" slot="end" *ngIf="auftragdetails.neutralAktuelleAnsicht == 2"></ion-icon>
        </ion-item>

        <hr />
    </ng-container>

    <ng-template ngFor let-b [ngForOf]="buttonsWorkflowStatusList">
        <ion-item button *ngIf="istStatusuebergangErlaubt(b)" appClick (clicked)="onStatusmeldung(b)" lines="none">{{ b.name }}</ion-item>
    </ng-template>

    <ion-item button *ngIf="weitereStatusmeldungenVerfuegbar" appClick (clicked)="onWeitereStatusmeldung()" lines="none">Mehr...</ion-item>
</ion-list>